<template>
    <div class="modal-name">
        <div class="left-name" :class="!redPlayer?'one-name':''">{{redPlayer?redPlayer.name:bluePlayer.name}}<span class="name-min"> ({{redPlayer?redPlayer.agencyName:bluePlayer.agencyName}}) </span></div>
        <div class="middle-name">{{technicalHeaderVo.matchTurnName}}</div>
        <div class="right-name" :class="redPlayer?'ranking-name':''" v-if="redPlayer">{{bluePlayer.name}}<span class="name-min"> ({{bluePlayer.agencyName}}) </span></div>
        <div v-else class="right-name"></div>
    </div>
</template>

<script>
export default {
  name:'StreeModalName',
  props:['technicalHeaderVo'],
  data () {
    return {
    }
  },
  computed: {
    bluePlayer () {
      return this.technicalHeaderVo.bluePlayer ||false 
    },
    redPlayer (){
      return this.technicalHeaderVo.redPlayer || false
    },
  },
  mounted () {
  },
}
</script>

<style lang="scss" scoped>
//标题名字
.modal-name{
width: 100%;
line-height: 40px;
display: flex;
box-sizing: border-box;
justify-content: flex-start;
text-align: center;
color: #FFFFFF;
font-size: 18px;
.name-min{
    font-size: 14px;
}
.left-name{
    width: 300px;
     background-color: #E51924;
    font-weight: 800;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.middle-name{
    width: 500px;
    background-color: #F6F6F6;
    color: #888888;
    font-size: 14px;
}
.right-name{
    width: 300px;
    font-weight: 800;
    background-color: #F6F6F6;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.ranking-name{
       background-color: #2773D5;
}
.one-name{
    background-color: #2773D5;  
    }
}

</style>


// WEBPACK FOOTER //
// src/comm/components/modal/stree/StreeModalName.vue